import { surveyChartTooltips } from "./survey_chart_tooltips";
import { surveyPDFChartAcquiredTooltips } from "./survey_pdf_chart_acquired_tooltips";
import { surveyTableTooltips } from "./survey_table_tooltips";

export const text = {
  surveyChartTooltips,
  surveyPDFChartAcquiredTooltips,
  surveyTableTooltips
};
